import { render, staticRenderFns } from "./BoardColumn.vue?vue&type=template&id=5af7f4db&scoped=true&"
import script from "./BoardColumn.vue?vue&type=script&lang=js&"
export * from "./BoardColumn.vue?vue&type=script&lang=js&"
import style0 from "./BoardColumn.vue?vue&type=style&index=0&id=5af7f4db&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af7f4db",
  null
  
)

export default component.exports